import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import CollegeReviews from './pages/CollegeReviews';
import PersonalizedList from './pages/PersonalizedList';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import About from './pages/About';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import RefundPolicy from './pages/RefundPolicy';
import CollegeDetails from './pages/CollegeDetails';
import SearchResults from './pages/SearchResults';
import StateColleges from './pages/StateColleges';
import StreamColleges from './pages/StreamColleges';
import SupabaseCollegeManager from './pages/SupabaseCollegeManager';
import PersonalizedCollegeManager from './pages/PersonalizedCollegeManager';
import BranchManager from './pages/BranchManager';
import AdminPanel from './pages/AdminPanel';
import PersonalizedListAdmin from './pages/PersonalizedListAdmin';
import JoSAAPersonalizedList from './pages/JoSAAPersonalizedList';
import JoSAAAdmin from './pages/JoSAAAdmin';
import BlogManager from './pages/BlogManager';
import CollegeManager from './pages/CollegeManager';
import SEOManager from './pages/SEOManager';
import SettingsManager from './pages/SettingsManager';
import StudentConnect from './pages/StudentConnect';

// Component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Toaster position="top-center" toastOptions={{ duration: 4000 }} />
        <div className="min-h-screen bg-white">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Navbar />
                <Home />
                <Footer />
              </>
            } />
            <Route path="/college-reviews" element={
              <>
                <Navbar />
                <CollegeReviews />
                <Footer />
              </>
            } />
            {/* Support both slug and ID for college details */}
            <Route path="/college/:slugOrId" element={
              <>
                <Navbar />
                <ErrorBoundary>
                  <CollegeDetails />
                </ErrorBoundary>
                <Footer />
              </>
            } />
            <Route path="/personalized-list" element={
              <>
                <Navbar />
                <PersonalizedList />
                <Footer />
              </>
            } />
            <Route path="/neet-college-predictor" element={
              <>
                <Navbar />
                <PersonalizedList />
                <Footer />
              </>
            } />
            <Route path="/josaa-personalized-list" element={
              <>
                <Navbar />
                <JoSAAPersonalizedList />
                <Footer />
              </>
            } />
            <Route path="/search" element={
              <>
                <Navbar />
                <SearchResults />
                <Footer />
              </>
            } />
            <Route path="/colleges/state/:state" element={
              <>
                <Navbar />
                <StateColleges />
                <Footer />
              </>
            } />
            <Route path="/colleges/stream/:stream" element={
              <>
                <Navbar />
                <StreamColleges />
                <Footer />
              </>
            } />
            <Route path="/blog" element={
              <>
                <Navbar />
                <ErrorBoundary>
                  <Blog />
                </ErrorBoundary>
                <Footer />
              </>
            } />
            <Route path="/blog/:slug" element={
              <>
                <Navbar />
                <ErrorBoundary>
                  <BlogPost />
                </ErrorBoundary>
                <Footer />
              </>
            } />
            <Route path="/about" element={
              <>
                <Navbar />
                <About />
                <Footer />
              </>
            } />
            <Route path="/contact" element={
              <>
                <Navbar />
                <Contact />
                <Footer />
              </>
            } />
            <Route path="/student-connect" element={
              <>
                <Navbar />
                <StudentConnect />
                <Footer />
              </>
            } />
            
            {/* Legal Pages */}
            <Route path="/terms" element={
              <>
                <Navbar />
                <Terms />
                <Footer />
              </>
            } />
            <Route path="/privacy" element={
              <>
                <Navbar />
                <Privacy />
                <Footer />
              </>
            } />
            <Route path="/refund-policy" element={
              <>
                <Navbar />
                <RefundPolicy />
                <Footer />
              </>
            } />
            
            {/* College Management Routes */}
            <Route path="/manage-colleges" element={
              <>
                <Navbar />
                <SupabaseCollegeManager />
                <Footer />
              </>
            } />
            <Route path="/manage-personalized-colleges" element={
              <>
                <Navbar />
                <PersonalizedCollegeManager />
                <Footer />
              </>
            } />
            <Route path="/manage-personalized-colleges/branches/:collegeId" element={
              <>
                <Navbar />
                <BranchManager />
                <Footer />
              </>
            } />
            <Route path="/admin" element={
              <>
                <Navbar />
                <AdminPanel />
                <Footer />
              </>
            } />
            <Route path="/admin/personalized-lists" element={
              <>
                <Navbar />
                <PersonalizedListAdmin />
                <Footer />
              </>
            } />
            <Route path="/admin/josaa-manager" element={
              <>
                <Navbar />
                <JoSAAAdmin />
                <Footer />
              </>
            } />
            <Route path="/admin/blog-manager" element={
              <>
                <Navbar />
                <BlogManager />
                <Footer />
              </>
            } />
            <Route path="/admin/college-manager" element={
              <>
                <Navbar />
                <CollegeManager />
                <Footer />
              </>
            } />
            <Route path="/admin/seo-manager" element={
              <>
                <Navbar />
                <SEOManager />
                <Footer />
              </>
            } />
            <Route path="/admin/settings" element={
              <>
                <Navbar />
                <SettingsManager />
                <Footer />
              </>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;